export enum LearnerLearningReminderFrequency {
    Weekly = 'weekly',
    Biweekly = 'biweekly',
    Monthly = 'monthly'
}
